module.exports = __webpack_public_path__ + "img/tuiguang2-1-1.752ccb70.png";